<template>
    <div class="panel">
        <div class="panel-heading">
            <h2 v-if="type==='campusSubmission'">Campus Submission</h2>
            <h2 v-else>Final Project Submission</h2>

        </div>
        <div class="panel-body">
            <div v-if="type==='campusSubmission'" class="campus-instructions">
                Submit your work made at campus below.<br><br>

                For information on reels:<br>
                <a href="https://portal.tttc.ca/#/kb-article/26">https://portal.tttc.ca/#/kb-article/26</a><br><br>

                For information on codecs:<br>
                <a href="https://portal.tttc.ca/#/kb-article/32">https://portal.tttc.ca/#/kb-article/32</a><br><br>
            </div>
            <div v-if="type==='demoReel' && text">
                <div class="final-project-intro-text" v-if="text.intro" v-html="text.intro[0].text"></div>
            </div>
            <form class="dam-fields">
                <dropzone id="finalProjectUpload" ref="finalProjectUpload" url="#" v-on:vdropzone-files-added="sendValidationAlert();triggerCoverflow($event)" v-bind:use-custom-dropzone-options="true" v-bind:thumbnail-height="0" v-bind:dropzone-options="dropzoneOptions">
                </dropzone>
                <coverflow :images="assetImages"></coverflow>
                <div class="form-group">
                    <label>Title *</label>
                    <input 
                        type="text" 
                        v-model="submission.title" 
                        class="form-control"
                        :placeholder='titlePlaceholder'
                        required
                        >
                </div>
                <div class="form-group" v-if="gallerySoftware">
                    <label>Software Used</label>
                    <software-select :options="gallerySoftware" :canCreate="false" v-model="submission.softwareUsed" placeholder="'Select all software used in the making of this project.'">
                    </software-select>
                </div>
                <div class="form-group">
                    <label>Tags</label>
                    <tag-select :search="searchTags" :canCreate="true" v-model="submission.tags" placeholder="'Short descriptive keywords describing the imagery, eg: sci-fi, warrior, sword, cat, ninja, castle, bird'">
                    </tag-select>
                </div>
                <div class="form-group" v-if="type==='campusSubmission' || type==='demoReel' && isCampusStudent">
                    <label>Industry Focus</label>
                    <select class="form-control" v-model="submission.industryFocus">
                        <option v-for="focus in industryFocuses" :key="focus">{{focus}}</option>
                    </select>
                </div>
                <div class="form-group final-project" v-if="type==='campusSubmission'">
                    <div>Final Project</div>
                    <label>Yes<input type="radio" v-model="submission.isFinalProject" value="Yes"><span class="toggle"></span></label>
                    <label>No<input type="radio" v-model="submission.isFinalProject" value="No"><span class="toggle"></span></label>
                </div>
                <div class="form-group" v-if="type==='campusSubmission'">
                    <label>Creation Date *</label>
                    <datepicker :option="dateOptions" :date="creationDate" v-model="creationDate"></datepicker>
                </div>
                <div class="form-group">
                    <label>Your Own Personal Artist Nickname / Alias</label>
                    <input type="text" class="form-control" v-model="submission.moniker" placeholder="If you have an artist moniker you prefer to be credited with instead of your real name, put it here">
                </div>
                <div class="form-group">
                    <label>Concept Credit *</label>
                    <input type="text" class="form-control" v-model="submission.conceptCredit" placeholder="Please be very sure to provide the correct name and spelling of the concept artist, if applicable">
                </div>
                <div class="form-group rookies-submission">
                    <input type="checkbox"  v-model="submission.isRookiesSubmission">
                    <label>Tick this box if this project will be submitted to The Rookies</label>
                </div>
                <div class="form-group" v-if="type !== 'campusSubmission'">
                    <label>Comments &amp; Questions</label>
                    <textarea class="form-control" v-model="submission.comments" rows="3"></textarea>
                </div>
                <button :disabled="submitting" type="submit" class="btn btn-success" @click.prevent="submitProject()">Submit</button>
            </form>
        </div>
    </div>
</template>
<script>
import Dropzone from 'vue2-dropzone';
import toastr from 'toastr';
import Datepicker from 'vue-datepicker';
import { groupBy, clone } from 'lodash';
import MP4Box from 'mp4box';
import fileToArrayBuffer from 'file-to-array-buffer';


import Coverflow from '../../../packages/coverflow/Coverflow.vue'
import SoftwareSelect from '../software-select';
import TagSelect from '../tag-select';

import Galleries from '../../../services/galleries';
import Assignments from '../../../services/assignments';
import AWS from '../../../services/aws';
import FinalProjects from '../../../services/final-projects';
import Cloudinary from '../../../services/cloudinary';
import cms from '../../../services/cms';


function parseFile(file, options) {
    var opts = typeof options === 'undefined' ? {} : options;
    var fileSize = file.size;
    var chunkSize = typeof opts['chunk_size'] === 'undefined' ? 64 * 1024 : parseInt(opts['chunk_size']); // bytes
    var binary = typeof opts['binary'] === 'undefined' ? false : opts['binary'] == true;
    var offset = 0;
    var self = this; // we need a reference to the current object
    var readBlock = null;
    var chunkReadCallback = typeof opts['chunk_read_callback'] === 'function' ? opts['chunk_read_callback'] : function() {};
    var chunkErrorCallback = typeof opts['error_callback'] === 'function' ? opts['error_callback'] : function() {};
    var success = typeof opts['success'] === 'function' ? opts['success'] : function() {};
    var result;

    var onLoadHandler = function(evt) {
        if (evt.target.error == null) {
            offset += evt.target.result.byteLength;
            chunkReadCallback(evt.target.result);
        } else {
            chunkErrorCallback(evt.target.error);
            return;
        }
        if (offset >= fileSize) {
            success(file);
            return;
        }

        readBlock(offset, chunkSize, file);
    }

    readBlock = function(_offset, length, _file) {
        var r = new FileReader();
        var blob = _file.slice(_offset, length + _offset);
        r.onload = onLoadHandler;
        if (binary) {
            r.readAsArrayBuffer(blob);
        } else {
            r.readAsText(blob);
        }
    }

    readBlock(offset, chunkSize, file);
}


async function validateCodec(file) {

    return new Promise(async (resolve, reject) => {

        let valid = true;

        const mp4boxfile = MP4Box.createFile();

        mp4boxfile.onError = function(e) {
            console.log(e)
        };

        mp4boxfile.onReady = function(info) {
            console.log("INFO")
            console.log(info);
            for (let track of info.tracks) {
                if (!track.codec.includes('mp4a')) { // ignore audio tracks
                    console.log(track.codec)
                    if (!track.codec.includes('avc1')) {
                        valid = false;
                    }
                    resolve(valid);
                }
            }
           
        }

        let offset = 0;
        const chunkSize = 64 * 1024;
        let i = 0;

        console.log("FS: " + file.size);

        const chunks = Math.ceil(file.size / chunkSize);
        for (let i = 0; i < chunks; i++) {   

            var r = new FileReader();
            var blob = file.slice(chunkSize * i, chunkSize * (i+1));

            r.onload = function(chunk) {
                const buffer = chunk.target.result;
                const fileStart = i * (chunkSize)
                buffer.fileStart = fileStart;
                mp4boxfile.appendBuffer(buffer);
                 mp4boxfile.flush();
            }

            r.readAsArrayBuffer(blob);
        }


    
    });

}
export default {
    props: ['type', 'assignment', 'demoReel'],
    data() {
        return {
            submitting: false,
            submission: {
                title: null,
                softwareUsed: [],
                tags: [],
                creationDate: null,
                moniker: null,
                conceptCredit: null,
                isRookiesSubmission: null,
                comments: null,
                isFinalProject: null,
                industryFocus: null,
            },
            industryFocuses: ['Film', 'Games', 'TV'],
            dropzoneOptions: {
                autoProcessQueue: false,
                addRemoveLinks: true,
                maxFilesize: 100,
                thumbnailHeight: 300,
                acceptedFiles: 'image/png,image/tiff,video/mp4',
                dictDefaultMessage: 'Drop images and videos here to upload<br>*.tiff (max 100mb each), *.png  (max 100mb each), *.mp4  (max 4000mb, h264) '
            },
            assetImages: [],
            gallerySoftware: null,
            creationDate: {
                time: ''
            },
            text: null,
            presetTags: null,
            dateOptions: {
                week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
                month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                placeholder: 'The date of completion of the project',
                format: 'YYYY-MM-DD',
                type: 'day',

            },
        }
    },
    components: {
        Dropzone,
        Coverflow,
        SoftwareSelect,
        Datepicker,
        TagSelect
    },
    mounted() {
        this.loadGallerySoftware();
        if (this.type === 'demoReel') {
            this.getText();
        }
        if (this.demoReel) {
            this.populateForm();
        }
    },
    watch: {
        demoReel: function() {
            if (this.demoReel && this.demoReel.cloudinaryMetadata) {
                this.populateForm();
            }
        }
    },
    methods: {
        searchTags: Galleries.searchTags,
        getText() {
            cms.get('FinalProject').then((response) => {
                console.log(response)
                this.text = groupBy(response.components, (c) => { return c.name });
            });
        },
        populateForm() {

            let previousSubmission;
            if (this.demoReel) {
                previousSubmission = this.demoReel;
            } else {
                previousSubmission = this.assignment.submissions[0];
            }
            const softwareUsed = previousSubmission.cloudinaryMetadata.softwareUsed;
            if (softwareUsed) this.submission.softwareUsed = softwareUsed;

            const tags = previousSubmission.tags;
            if (tags) this.submission.tags = tags;

            this.submission.industryFocus = previousSubmission.cloudinaryMetadata.industryFocus;

            this.submission.moniker = previousSubmission.cloudinaryMetadata.moniker;

            this.submission.title = previousSubmission.cloudinaryMetadata.title;

            if (previousSubmission.isRookiesSubmission && previousSubmission.isRookiesSubmission === '0001') {
                this.submission.previousSubmission = true;
            }

            this.submission.conceptCredit = previousSubmission.cloudinaryMetadata.conceptCredit;

            this.submission.isRookiesSubmission = previousSubmission.cloudinaryMetadata.isRookiesSubmission;


        },

        async loadGallerySoftware() {
            try {
                this.gallerySoftware = await Galleries.getAllSoftware();

                if (this.assignment &&
                    this.assignment.submissions &&
                    this.assignment.submissions.length > 0 &&
                    this.assignment.submissions[0].cloudinaryMetadata) {
                    this.populateForm();
                }

            } catch (error) {
                toastr.error(`
                        There was an error while loading the software.
                        Please try again later.
                    `);
                throw error;
            }
        },
        validateSubmission: function() {
            let validation = {
                valid: true,
                message: ''
            }

            const allowedFileTypes = ['tiff', 'tif', 'mp4', 'png'];

            const files = this.$refs.finalProjectUpload.dropzone.files;



            if (files.length < 1) {
                validation.valid = false;
                validation.message = 'Please add at least one asset';
            }


            for (let file of files) {

                const type = file.type.split('/').pop();
                if (!allowedFileTypes.includes(type)) {
                    validation.valid = false;
                    validation.message = 'Please upload only TIFF, PNG, and MP4 files';
                }


               if (file.type.includes('image')) {                
                    if (file.size >= 100000000) {
                        validation.valid = false;
                        validation.message = 'Image(s) Exceed 100mb Limit. ';
                    }
                }
                else {
                    if (file.size >= 4000000000) {
                        validation.valid = false;
                        validation.message = 'Media file(s) Exceed 4gb Limit.';
                    }
                }

                const asset = this.assetImages.find(a => a.name === file.name);

                if (!asset.descriptor || asset.descriptor === '') {
                    validation.valid = false;
                    validation.message = 'Please add a caption to every asset';
                }
                if (asset.disciplines.length < 2) {
                    validation.valid = false;
                    validation.message = 'Please add at least two disciplines to each asset';
                }
            }

            if (this.type === 'demoReel') {
                const hasVideo = files.find(f => f.type === 'video/mp4');
                if (!hasVideo) {
                    validation.valid = false;
                    validation.message = 'Please include your demo reel in MP4 format';
                }

                if (!this.demoReel) {
                    const hasRenders = files.find((f) => { return f.type !== 'video/mp4' });
                    if (!hasRenders) {
                        validation.valid = false;
                        validation.message = 'Please include still renders on your first demo reel submission.';
                    }
                }


            }

            if (this.type === 'campusSubmission') {
                if (!this.submission.title || this.submission.title.trim() === '') {
                    validation.valid = false;
                    validation.message = 'Please add a title';
                }
                if (!this.creationDate.time || this.creationDate.time === '') {
                    validation.valid = false;
                    validation.message = 'Please add a creation date';
                }
                if (!this.submission.isFinalProject) {
                    validation.valid = false;
                    validation.message = 'Please indicate whether this is a final project';
                }
            }

            if (!this.submission.conceptCredit) {
                validation.valid = false;
                validation.message = 'Please submit a concept credit';
            }

            if (this.submission.conceptCredit && this.submission.conceptCredit.length > 200) {
                validation.valid = false;
                validation.message = 'Concept credit must be less than 200 characters';
            }


            return validation;
        },

        submitProject() {
            this.submitting = true;

            const validation = this.validateSubmission();


            if (validation.valid === false) {
                toastr.error(validation.message);
                this.submitting = false;
                return false;
            }



            const submission = this.submission;
            submission.url = [];
            submission.sendToDAM = true;
            submission.assetImages = this.assetImages.map((i) => { delete i.src; return i; });
            submission.studentId = localStorage.account_id;

            if (this.type === 'finalAssignment') {
                submission.isFinalProject = true;
                submission.instanceId = this.assignment.instanceId;
                submission.assignmentId = this.assignment.id;
            } else if (this.type === 'demoReel') {
                submission.thumbnail = null;
                submission.stillRenders = [];
                submission.demoReel = null;
            } else if (this.type === 'campusSubmission') {
                submission.creationDate = this.creationDate.time.split('T')[0];
            }


            const files = this.$refs.finalProjectUpload.dropzone.files;
            const promises = [];

            let bucket;

            if (this.type === 'finalAssignment') {
                bucket = 'ttto-assignment-submissions';
            } else if (this.type === 'demoReel') {
                bucket = 'tto-demo-reels';
            } else if (this.type === 'campusSubmission') {
                bucket = 'tto-campus-submissions';
            }

            for (let file of files) {

                const filename = file.name.replace(/ /g, '_').replace(/&|\$|@|=|;|:|\%|\+|,|\?/g, '').replace(/\.[^/.]+$/, "") + '_' + new Date().getMilliseconds() + parseInt(Math.random() * 100) + '.' + file.name.split('.').pop();
                const promise = new Promise(async (resolve, reject) => {
                    const signature = await AWS.signature(file, filename, bucket);
                    const presignedUrl = await AWS.getPresignedUrl(this, bucket, filename, 'putObject', false);

                    const acceleratedUrl = presignedUrl.data.replace('s3.us-west-2','s3-accelerate');

                    const upload = await AWS.upload(file, filename, signature, bucket, acceleratedUrl);


                    if (this.type === 'finalAssignment' || this.type === 'campusSubmission') {
                        submission.url.push(upload.url);
                    } else if (this.type === 'demoReel') {
                        if (file.type.includes('video')) {
                            submission.demoReel = upload.url;
                        } else {
                            submission.stillRenders.push(upload.url);
                        }
                    }

                    const asset = submission.assetImages.find(a => a.name === file.name);
                    asset.url = upload.url;

                    resolve();
                });
                promises.push(promise);
            }

            Promise.all(promises).then(async () => {
                let response;

                if (this.type === 'demoReel') {
                    response = await FinalProjects.create(this.submission)
                } else if (this.type === 'finalAssignment') {
                    response = await Assignments.submit(this, submission);
                } else if (this.type === 'campusSubmission') {
                    response = await Cloudinary.create(submission);
                }


                this.submitting = false;

                if (response.data.success === true) {

                    toastr.success('Successfully submitted');


                    if (this.type === 'campusSubmission') {
                        this.submission = {
                            title: null,
                            softwareUsed: [],
                            tags: [],
                            creationDate: null,
                            moniker: null,
                            conceptCredit: null,
                            isRookiesSubmission: null,
                            comments: null,
                            isFinalProject: null
                        };
                        this.creationDate = {
                            time: ''
                        }
                        this.assetImages = [];
                        this.$refs.finalProjectUpload.dropzone.removeAllFiles(true);

                    } else {
                        this.assetImages = [];
                        this.$refs.finalProjectUpload.dropzone.removeAllFiles(true);
                        this.$bus.$emit('reload_assignment');
                        this.$forceUpdate();
                    }
                } else {
                    if (response.data.message) {
                        toastr.error(response.data.message);
                    } else {
                        toastr.error('Error submitting');
                    }
                }
            });
        },
        sendValidationAlert() {
            toastr.info('Validating files -- please wait');
        },
        triggerCoverflow(e) {
            // give the UI time to render the validation info toast before the browser starts loading the potentially massive file into memory
            setTimeout(()=>{
                this.populateCoverflow(e);
            },300)
        },
        populateCoverflow(e) {


            this.$nextTick(async () => {


                const allFiles = this.$refs.finalProjectUpload.dropzone.files;

                const allowedTypes = ['image/tiff', 'video/mp4', 'image/png'];

                e = Array.from(e);

                for (let [index, file] of e.entries()) {

                    if (allowedTypes.includes(file.type)) {

                        if (file.type.includes('video')) {
                           
                            const validCodec = await validateCodec(file);
                            console.log(validCodec)
                           

                            if (validCodec === false) {
                                toastr.error('Please use only h264 encoding')
                                this.$refs.finalProjectUpload.dropzone.removeFile(file);
                                continue;

                            } else {
                                console.log('THIS IS OK')
                            }
                        }


                        let src;

                        if (file.type.includes('video')) {
                            src = './../../static/static/img/film-placeholder.png';
                        } else {
                            src = './../../static/static/img/image-placeholder.png';
                        }

                        this.assetImages.push({
                            name: file.name,
                            src: src,
                            descriptor: null,
                            disciplines: []
                        });

                        console.log(this.assetImages)


                    } else {
                        toastr.error('Please upload only TIFFs, PNGs, or MP4s');
                        this.$refs.finalProjectUpload.dropzone.removeFile(file);

                    }
                }
            });
        }
    },
    computed: {
        titlePlaceholder() {
            if (localStorage.terms.split(',').length === 1 && this.type === 'finalAssignment') { // this is a Foundation student's final assignment
                return 'Should be artistic. Use same title as concept, if applicable. Do not use generic title eg: “Final Project”';
            }
            else {
                return 'Should be artistic (eg "A Starry Night"), not generic (eg "Final Project")';
            }
        },
        isCampusStudent() {
            return localStorage.roles.includes('CampusStudent') || localStorage.transitioned == 'true';
        }
    }
}

</script>

</style>
<style lang="scss">
.dz-message .material-icons {
    // display:none;
}
.rookies-submission {
    display:flex;
    align-items:center;
    input {        
        position: relative;
        top:-2px;
        cursor: pointer;
    }
    label {
        margin-left:1rem;
    }

}
.final-project-intro-text {
    margin-bottom: 2rem;
}

.demo-reel-submission,
.campus-submission {
    .panel-body {
        padding: 2rem !important;
    }

    .dropzone .dz-preview {
        display: none !important;

    }
}

.final-project-submission-modal {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, .5);
    z-index: 999999;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow-y: scroll;
    -ms-overflow-style: none;
    scrollbar-width: none;

    .panel {
        width: 800px;
        max-width: 100%;
        max-height: 90vh;

        .panel-body {
            padding: 2rem !important;
        }
    }

}

.final-project-submission-modal::-webkit-scrollbar {
    display: none;
}

.final-project-submission-modal {
    .dropzone .dz-preview {
        display: none !important;
    }
}

.close-modal {
    position: absolute;
    top: 1rem;
    right: 1rem;
    font-size: 2rem !important;
    cursor: pointer;
}

.dam-fields {
    .cov-vue-date {
        display: block;
        width: 100% !important;

        .cov-datepicker {
            border: none !important;
            background: transparent !important;
            box-shadow: none !important;
            border-bottom: 1px solid #fff !important;
            width: 100% !important;
        }
    }


    .datepicker-overlay {
        .cov-date-body {
            background-color: #3cf !important;

            .cov-date-caption {
                color: #000 !important;
            }

            .cov-date-previous::before,
            .cov-date-previous::after,
            .cov-date-next::before,
            .cov-date-next::after {
                background: #000 !important;
            }

            .cov-picker-box,
            .button-box {
                background: #222222;
                color: #b0b0b0 !important;
            }

            .week ul>li,
                {
                color: #b0b0b0 !important;
            }

            .checked {
                background: #3cf !important;
                color: #000 !important;
            }

        }

        .day {
            background: #222;
            color: #b0b0b0;
        }
    }

    .v-select {
        padding: 4px 0;

        .selected-tag {
            background: transparent;
            border: solid 1px #33ccff;
            border-radius: 4px;
            color: #33ccff;
            margin: 4px 5px 4px 0;
            padding: 3px 8px;
            line-height: 18px;
            font-size: 12px;

            .close {
                color: #33ccff;
                opacity: 0.8;
                line-height: 17px;
                font-size: 16px;

            }
        }

        .dropdown-toggle {
            border: none;
        }

        .dropdown-menu {
            background-color: #363636;
            border: 1px solid #666;
            padding: 0;
            overflow-y: auto;
            max-height: 200px;

            li a {
                color: #ebebeb;
            }

            li.highlight a {
                color: white;
            }
        }

        .clear {
            color: #555;
        }

        .open-indicator::before {
            border-color: #b0b0b0;
        }


    }

    .final-project {
        label {
            display: flex;
            cursor: pointer;
            flex-direction: row-reverse;
            justify-content: flex-end;
        }

        .toggle {
            border: 1px solid #3cf;
            display: inline-block;
            width: 16px;
            height: 16px;
            border-radius: 50%;
            position: relative;
            top: 2px;
            margin-right: 8px;
        }

        input {
            display: none;
        }

        input:checked+.toggle {
            background: #3cf;
        }
    }

}

</style>



// WEBPACK FOOTER //
// DAMSubmission.vue?6c26af7e